import { render, staticRenderFns } from "./ViewContainer.vue?vue&type=template&id=dfbd52ae&scoped=true&"
import script from "./ViewContainer.vue?vue&type=script&lang=js&"
export * from "./ViewContainer.vue?vue&type=script&lang=js&"
import style0 from "./ViewContainer.vue?vue&type=style&index=0&id=dfbd52ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbd52ae",
  null
  
)

export default component.exports